<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="mt-6 shadow sm:rounded-sm bg-white p-6 text-sm text-gray-700">
                {{ $t('New process steps can only be created via development.') }}
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: "process-steps-new",
    metaInfo() {
        return {
            title: this.$i18n.t('Create process step')
        }
    },
    mounted() {
        this.$router.replace('/workspace/admin/settings/process-steps');
        this.$notify({
            title: this.$i18n.t('Error').toString(),
            text: this.$i18n.t('New process steps cannot be created.').toString(),
            type: 'error'
        });
    },
}
</script>
